import React from "react";
import * as cls from "./academicDept.module.scss";
import ArrowRight from "../../resources/icons/ArrowRight";
import { useSelector } from "react-redux";
// ЗЕТ в виджете "Академическая разница" открываются в `ModalZetLessons`.
import { useDispatch } from "react-redux";
import {
  showZetLessonDetailAction,
  zetLessonDetailDataAction,
} from "../../redux/actions/actions";
import { TableLoader } from "../tableLoader";
import { TableModel } from "../../../personal-studio-components/table/TableModel";
import { StudentService } from "../studentService";
/** Виджет Академическая разница на главной странице */
export default function AcademicDept({ menu }) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);

  const dispatch = useDispatch();
  async function openLesson(row) {
    const discip_short_name = row.cur_discip_name;
    const zet_name = row.zet_name;
    const request = {
      method: "post",
      path: "/student/linegraph/discip/lessons",
      data: {
        access_token,
        study_contract_id: contractId,
        semester_id: row.semester_id,
        ind_mod_discip_id: row.ind_mod_discip_id,
      },
    };
    console.debug("AcademicDept: open", row);
    dispatch(showZetLessonDetailAction(true));
    await StudentService.send(request, (response) => {
      if (response) {
        dispatch(
          zetLessonDetailDataAction({
            lessons: response,
            discip_short_name,
            zet_name,
          })
        );
      }
    });
  }
  const loader = {
    title: "Академический лаг",
    icon: "folder_open",
    request: {
      method: "post",
      path: "/student/widget/academic_debt",
      data: {
        access_token,
        study_contract_id: contractId,
        return_row_value: 0,
      },
    },
    parser: createModel,
  };
  function createModel(response) {
    const table = new TableModel(response);
    table.columns = table.columns.filter(
      (el) => el.field === "cur_discip_name" || el.field === "url"
    );
    table.columns.forEach((col) => {
      if (col.field === "url") {
        col.type = "jsx";
      }
    });
    table.rows = table.rows.map((row) => ({
      ...row,
      url: (
        <div
          className={cls.academic_difference_tbody_tr_td_certification}
          onClick={() => openLesson(row) /*startAttestation(el.url)*/}
        >
          Перейти в занятие
          <span
            className={cls.academic_difference_tbody_tr_td_certification_arrow}
          >
            <ArrowRight />
          </span>
        </div>
      ),
    }));
    table.maxHeight = "20rem";
    return table;
  }
  return (
    <TableLoader
      {...loader}
      menu={menu}
      type="magenta"
      icon={"folder_open"}
      title={"Академический лаг"}
    />
  );
}
